/**
 * Types
 */
import DADOS_SIM from './../../consts/consts';

export const DadosClienteTypes = {
    OBTER_AGENCIA_REQUEST: 'dados-cliente/OBTER_AGENCIA_REQUEST',
    OBTER_AGENCIA_SUCCESS: 'dados-cliente/OBTER_AGENCIA_SUCCESS',
    OBTER_AGENCIA_FAIL: 'dados-cliente/OBTER_AGENCIA_FAIL',
    SET_COTACAO: 'dados-cliente/SET_COTACAO',
    RESET: 'dados-cliente/RESET'
};

/**
 * Reducer
 */
let INITIAL_STATE = {
    cotacao: null
};

export function dadosClienteReducer(state = [INITIAL_STATE], action) {
    const fValue = DADOS_SIM.DADOS_CLIENTE;
    switch (action.type) {
        case DadosClienteTypes.RESET: {
            return { ...INITIAL_STATE };
        }
        case DadosClienteTypes.OBTER_AGENCIA_REQUEST: {
            return {
                ...state,
                nomeAgenciaLoading: true
            };
        }
        case DadosClienteTypes.SET_COTACAO: {
            return {
                ...state,
                cotacao: action.payload.cotacao
            };
        }
        case DadosClienteTypes.OBTER_AGENCIA_SUCCESS:
            return {
                ...state,
                [fValue.NOME_AGENCIA]: action.payload.data[fValue.NOME_AGENCIA],
                nomeAgenciaLoading: false
            };
        case DadosClienteTypes.OBTER_AGENCIA_FAIL:
            return {
                ...state,
                msgErroNomeAgencia: action.payload,
                nomeAgenciaLoading: false
            };
        default:
            return state;
    }
}

/**
 * Actions
 */
export const Creators = {
    buscaAgenciaRequest: (numAgencia) => ({
        type: DadosClienteTypes.OBTER_AGENCIA_REQUEST,
        payload: { numAgencia }
    }),

    buscaAgenciaSuccess: (data) => ({
        type: DadosClienteTypes.OBTER_AGENCIA_SUCCESS,
        payload: { data }
    }),

    buscaAgenciaFailure: (error) => ({
        type: DadosClienteTypes.OBTER_AGENCIA_FAIL,
        payload: { error }
    }),

    setCotacao: (cotacao) => ({
        type: DadosClienteTypes.SET_COTACAO,
        payload: { cotacao }
    }),
    reset: () => ({
        type: DadosClienteTypes.RESET
    })
};
